/** Backend cap for `cancellationNote` on `POST /api/Appointment/Cancel`. */
export const CANCELLATION_NOTE_MAX = 500;

/**
 * Trims the typed note and returns `{ cancellationNote }` only when something
 * is left, so the key is absent from the single-cancel body when empty.
 */
export function cancellationNoteBody(raw: string): { cancellationNote?: string } {
  const trimmed = raw.trim();
  return trimmed === '' ? {} : { cancellationNote: trimmed };
}
